import { BookingFlow } from "../booking-flows/types";
import { saveScreeningResponses, saveUserScreeningResponses } from "./api";
import {
  AuthenticatedScreeningPayload,
  NewPatientScreeningPayload,
  ScreeningApiPayload,
} from "./types";

type SaveScreeningProps = {
  bookingFlowId: BookingFlow["id"];
  payload: ScreeningApiPayload;
};

type SaveUserScreeningProps = {
  bookingFlowId: BookingFlow["id"];
  payload: NewPatientScreeningPayload | AuthenticatedScreeningPayload;
};

export const mutations = {
  saveScreening: ({ bookingFlowId, payload }: SaveScreeningProps) =>
    saveScreeningResponses(bookingFlowId, payload),
  saveUserScreening: ({ bookingFlowId, payload }: SaveUserScreeningProps) =>
    saveUserScreeningResponses(bookingFlowId, payload),
};
